var React = require('react');

function Angular (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#B3B3B3","d":"M63.81 1.026l-59.257 20.854 9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635z","key":0}),React.createElement("path",{"fill":"#A6120D","d":"M117.536 25.998l-53.864-18.369v112.785l45.141-24.983z","key":1}),React.createElement("path",{"fill":"#DD1B16","d":"M11.201 26.329l8.026 69.434 44.444 24.651v-112.787z","key":2}),React.createElement("path",{"fill":"#F2F2F2","d":"M78.499 67.67l-14.827 6.934h-15.628l-7.347 18.374-13.663.254 36.638-81.508 14.827 55.946zm-1.434-3.491l-13.295-26.321-10.906 25.868h10.807l13.394.453z","key":3}),React.createElement("path",{"fill":"#B3B3B3","d":"M63.671 11.724l.098 26.134 12.375 25.888h-12.446l-.027 10.841 17.209.017 8.042 18.63 13.074.242z","key":4})]);
}

Angular.defaultProps = {"className":"tag-icon","width":"128","height":"128","viewBox":"0 0 128 128"};

module.exports = Angular;

Angular.default = Angular;
